/**
 * Map model values through dataToEntity (display → internal).
 */
export function mapToEntities(
  modelValue: any[],
  dataToEntity?: (data: any) => any,
): any[] {
  if (dataToEntity) {
    return modelValue ? modelValue.map(dataToEntity) : [];
  }
  return modelValue;
}

/**
 * Map internal values back through dataFromEntity and emit.
 */
export function mapFromEntities(
  val: any[],
  dataFromEntity: ((data: any) => any) | undefined,
  emit: (mapped: any[]) => void,
): void {
  if (dataFromEntity !== undefined) {
    emit(val.map(dataFromEntity));
  } else {
    emit(val);
  }
}
